import { render, staticRenderFns } from "./Surface.vue?vue&type=template&id=2ff5410e&"
import script from "./Surface.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Surface.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports